import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import Geometry from './Geometry';
import CoordinateFilter from './CoordinateFilter';
import hasInterface from '../../../../hasInterface';
import GeometryComponentFilter from './GeometryComponentFilter';
import Dimension from './Dimension';
import GeometryFilter from './GeometryFilter';
import CoordinateSequenceFilter from './CoordinateSequenceFilter';
import Puntal from './Puntal';
import Envelope from './Envelope';
import Assert from '../util/Assert';
var Point = /*#__PURE__*/function (_Geometry) {
  _inherits(Point, _Geometry);
  function Point() {
    var _this;
    _classCallCheck(this, Point);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Point).call(this));
    Point.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(Point, [{
    key: "computeEnvelopeInternal",
    value: function computeEnvelopeInternal() {
      if (this.isEmpty()) return new Envelope();
      var env = new Envelope();
      env.expandToInclude(this._coordinates.getX(0), this._coordinates.getY(0));
      return env;
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      return this.isEmpty() ? [] : [this.getCoordinate()];
    }
  }, {
    key: "copyInternal",
    value: function copyInternal() {
      return new Point(this._coordinates.copy(), this._factory);
    }
  }, {
    key: "equalsExact",
    value: function equalsExact() {
      if (arguments.length === 2 && typeof arguments[1] === 'number' && arguments[0] instanceof Geometry) {
        var other = arguments[0],
          tolerance = arguments[1];
        if (!this.isEquivalentClass(other)) return false;
        if (this.isEmpty() && other.isEmpty()) return true;
        if (this.isEmpty() !== other.isEmpty()) return false;
        return this.equal(other.getCoordinate(), this.getCoordinate(), tolerance);
      } else {
        return _get(_getPrototypeOf(Point.prototype), "equalsExact", this).apply(this, arguments);
      }
    }
  }, {
    key: "normalize",
    value: function normalize() {}
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._coordinates.size() !== 0 ? this._coordinates.getCoordinate(0) : null;
    }
  }, {
    key: "getBoundaryDimension",
    value: function getBoundaryDimension() {
      return Dimension.FALSE;
    }
  }, {
    key: "reverseInternal",
    value: function reverseInternal() {
      return this.getFactory().createPoint(this._coordinates.copy());
    }
  }, {
    key: "getTypeCode",
    value: function getTypeCode() {
      return Geometry.TYPECODE_POINT;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return 0;
    }
  }, {
    key: "getNumPoints",
    value: function getNumPoints() {
      return this.isEmpty() ? 0 : 1;
    }
  }, {
    key: "getX",
    value: function getX() {
      if (this.getCoordinate() === null) throw new IllegalStateException('getX called on empty Point');
      return this.getCoordinate().x;
    }
  }, {
    key: "compareToSameClass",
    value: function compareToSameClass() {
      if (arguments.length === 1) {
        var other = arguments[0];
        var point = other;
        return this.getCoordinate().compareTo(point.getCoordinate());
      } else if (arguments.length === 2) {
        var _other = arguments[0],
          comp = arguments[1];
        var _point = _other;
        return comp.compare(this._coordinates, _point._coordinates);
      }
    }
  }, {
    key: "apply",
    value: function apply() {
      if (hasInterface(arguments[0], CoordinateFilter)) {
        var filter = arguments[0];
        if (this.isEmpty()) return null;
        filter.filter(this.getCoordinate());
      } else if (hasInterface(arguments[0], CoordinateSequenceFilter)) {
        var _filter = arguments[0];
        if (this.isEmpty()) return null;
        _filter.filter(this._coordinates, 0);
        if (_filter.isGeometryChanged()) this.geometryChanged();
      } else if (hasInterface(arguments[0], GeometryFilter)) {
        var _filter2 = arguments[0];
        _filter2.filter(this);
      } else if (hasInterface(arguments[0], GeometryComponentFilter)) {
        var _filter3 = arguments[0];
        _filter3.filter(this);
      }
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      return this.getFactory().createGeometryCollection();
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return Geometry.TYPENAME_POINT;
    }
  }, {
    key: "getCoordinateSequence",
    value: function getCoordinateSequence() {
      return this._coordinates;
    }
  }, {
    key: "getY",
    value: function getY() {
      if (this.getCoordinate() === null) throw new IllegalStateException('getY called on empty Point');
      return this.getCoordinate().y;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._coordinates.size() === 0;
    }
  }, {
    key: "init",
    value: function init(coordinates) {
      if (coordinates === null) coordinates = this.getFactory().getCoordinateSequenceFactory().create([]);
      Assert.isTrue(coordinates.size() <= 1);
      this._coordinates = coordinates;
    }
  }, {
    key: "isSimple",
    value: function isSimple() {
      return true;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Puntal];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._coordinates = null;
      var coordinates = arguments[0],
        factory = arguments[1];
      Geometry.constructor_.call(this, factory);
      this.init(coordinates);
    }
  }]);
  return Point;
}(Geometry);
export { Point as default };